class GallerySlider {
  constructor() {
    this.slideIndex = 1;
  }

  plusSlides(n) {
    this.slideIndex = this.slideIndex + n;
    this.showSlides(this.slideIndex);
  }

  showSlides(n) {
    var i;
    var slides = document.getElementsByClassName("img-wrapper");
    if (n > slides.length) {
      this.slideIndex = 1;
    }
    if (n < 1) {
      this.slideIndex = slides.length;
    }
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    var nextImg = slides[this.slideIndex - 1].querySelector('.media-img img');
    slides[this.slideIndex - 1].style.display = "block";
    if (!nextImg.src) {
      nextImg.src = nextImg.dataset['src'];
    }
    document.querySelector('.current.js-current').innerHTML = this.slideIndex;
    document.querySelector('.js-caption').innerHTML = nextImg.alt;
  }
}

export default function () {
  var gllerySlider = new GallerySlider();
  gllerySlider.showSlides(1);
  document.querySelector('.slide-nav .prev').addEventListener('click', () => gllerySlider.plusSlides(-1));
  document.querySelector('.slide-nav .next').addEventListener('click', () => gllerySlider.plusSlides(1));

  document.addEventListener("keyup", event => {
    switch (event.keyCode) {
      case 37:
        return gllerySlider.plusSlides(-1);
      case 39:
        return gllerySlider.plusSlides(1);
      default:
        return null;
    }
  });
}
